import { formatCurrency } from '../../../../utils/collateralFormatters';

interface SummaryCardProps {
    label: string;
    total: number | string;
    validated: number | string;
    isCurrency?: boolean;
}

const SummaryCard = ({ label, total, validated, isCurrency = false }: SummaryCardProps) => {
    const numTotal = typeof total === 'string' ? parseFloat(total) || 0 : total;
    const numValidated = typeof validated === 'string' ? parseFloat(validated) || 0 : validated;
    const pct = numTotal > 0 ? Math.round((numValidated / numTotal) * 100) : 0;

    return (
        <div className="bg-gray-50 dark:bg-slate-800 rounded-lg p-2.5">
            <div className="flex justify-between text-sm mb-1.5">
                <span className="text-gray-500">{label}</span>
                <span className="dark:text-white font-medium">{isCurrency ? formatCurrency(numTotal) : numTotal}</span>
            </div>
            <div className="flex justify-between text-sm mb-1">
                <span className="text-gray-400 text-xs">Validados</span>
                <span className="text-green-600 font-medium">{isCurrency ? formatCurrency(numValidated) : numValidated}</span>
            </div>
            <div className="w-full bg-gray-200 dark:bg-slate-700 rounded-full h-1.5">
                <div className="bg-green-500 h-1.5 rounded-full transition-all" style={{ width: `${pct}%` }} />
            </div>
            <div className="text-right text-xs text-green-600 mt-0.5">{pct}%</div>
        </div>
    );
};

export default SummaryCard;
